export const POSITION_ZINDEX = 510;
export const CLUSTER_ZINDEX = 505;
export const SELECTED_TRACK_ZINDEX = 495;
export const FEATURE_COLLECTION_ZINDEX = 480;
export const TRACK_ZINDEX = 490;
export const POINTER_TRACK_ZINDEX = 480;
export const FLAG_TRACK_ZINDEX = 470;
export const ALERT_POI_RADIUS = 100;

export const TRACK_DIRECTIVE_ZINDEX = 500;
export const ITINERARY_ZINDEX = 600;
export const UGC_TRACK_ZINDEX = 490;
export const UGC_POI_ZINDEX = 500;
export const UGC_POI_DRAWN_ZINDEX = 610;
export const TRACK_RECORD_ZINDEX = 450;
